var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          attrs: {
            title: _vm.title,
            "close-on-click-modal": false,
            visible: _vm.visible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _vm.method != "add"
            ? _c(
                "el-button",
                {
                  staticClass: "mb8",
                  attrs: {
                    size: "medium",
                    icon: _vm.method == "view" ? "el-icon-edit" : "",
                    type: _vm.method == "view" ? "warning" : "primary",
                    plain: _vm.method == "view" ? false : true,
                    disabled: !_vm.hasPermission("about:cecAbout:edit"),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.handEditorView(_vm.method)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.method == "view" ? "编辑" : "取消"))]
              )
            : _vm._e(),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "inputForm",
              class: _vm.method === "view" ? "readonly" : "",
              attrs: {
                model: _vm.inputForm,
                size: "small",
                disabled: _vm.method === "view",
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 15 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "名称",
                            prop: "name",
                            rules: [
                              {
                                required: true,
                                message: "名称不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请填写名称",
                              maxlength: "64",
                            },
                            model: {
                              value: _vm.inputForm.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "name", $$v)
                              },
                              expression: "inputForm.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "所属位置或栏目",
                            prop: "position",
                            rules: [
                              {
                                required: true,
                                message: "所属位置或栏目不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请填写所属位置或栏目",
                              maxlength: "64",
                            },
                            model: {
                              value: _vm.inputForm.position,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "position", $$v)
                              },
                              expression: "inputForm.position",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "英文值",
                            prop: "valEn",
                            rules: [
                              {
                                required: true,
                                message: "英文值不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              placeholder: "请填写英文值",
                            },
                            model: {
                              value: _vm.inputForm.valEn,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "valEn", $$v)
                              },
                              expression: "inputForm.valEn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "中文值", prop: "valCn", rules: [] },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              placeholder: "请填写中文值",
                            },
                            model: {
                              value: _vm.inputForm.valCn,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "valCn", $$v)
                              },
                              expression: "inputForm.valCn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "链接或路由",
                            prop: "url",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请填写链接或路由",
                              maxlength: "64",
                            },
                            model: {
                              value: _vm.inputForm.url,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "url", $$v)
                              },
                              expression: "inputForm.url",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "图片", prop: "pic", rules: [] } },
                        [
                          _c("image-upload", {
                            attrs: {
                              disabled: _vm.method === "view",
                              limit: 3,
                              tip: "最多上传3个图片,单个图片不要超过10M",
                            },
                            model: {
                              value: _vm.inputForm.pic,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "pic", $$v)
                              },
                              expression: "inputForm.pic",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    size: "medium",
                    type: "danger",
                    icon: "el-icon-close",
                  },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _vm.method != "view"
                ? _c(
                    "el-button",
                    {
                      directives: [
                        { name: "noMoreClick", rawName: "v-noMoreClick" },
                      ],
                      attrs: {
                        size: "medium",
                        type: "success",
                        icon: "el-icon-check",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.doSubmit()
                        },
                      },
                    },
                    [_vm._v("确定")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }